export function Loading({ label = "Loading…", className = "" }: { label?: string; className?: string }) {
  return <div className={`text-slate-500 text-sm ${className}`}>{label}</div>;
}

export function ErrorState({
  onRetry,
  message = "Something went wrong loading this.",
}: {
  onRetry?: () => void;
  message?: string;
}) {
  return (
    <div className="rounded-lg border border-rose-900/50 bg-rose-950/20 p-4 text-sm text-rose-200 flex items-center justify-between gap-3">
      <span>{message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded border border-rose-700/70 hover:border-rose-500 px-3 py-1 text-rose-100 whitespace-nowrap"
        >
          Retry
        </button>
      )}
    </div>
  );
}
